/**
 * NFT mapper - converts API response types to domain entities
 */
import type { NftResponse } from "../../shared/api/nft";
import type { Nft, WalletNetwork } from "./model";

/**
 * Map API NftResponse to domain Nft entity
 */
export function mapNftResponseToEntity(response: NftResponse): Nft {
  return {
    id: response.id,
    collectionAddress: response.collectionAddress,
    itemAddress: response.itemAddress,
    tokenId: response.tokenId,
    network: response.network as WalletNetwork,
    ownerAddress: response.ownerAddress,
    ownerWalletId: response.ownerWalletId,
    ownerUserId: response.ownerUserId,
    metadataUri: response.metadataUri,
    name: response.name,
    description: response.description,
    previewImage: response.previewImage,
    attributes:
      response.attributes && typeof response.attributes === "object"
        ? (response.attributes as Record<string, unknown>)
        : null,
    lastSyncAt: response.lastSyncAt ? new Date(response.lastSyncAt) : null,
    lastKnownLt: response.lastKnownLt,
    lastKnownTxHash: response.lastKnownTxHash,
    createdAt: new Date(response.createdAt),
    updatedAt: new Date(response.updatedAt),
  };
}

